module.exports = __webpack_public_path__ + "img/SP3-C.55471679.jpg";